import React, { useState, useEffect } from 'react';
import './ConfirmationFooter.css';
import Logo from '../../../../assets/img/sobre-rodas.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopyright } from '@fortawesome/free-solid-svg-icons';
import { Text } from '../../../../components/Text';

const ConfirmationFooter = ({ notShowLogo }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <footer className="confirmation-footer">
      <div className="footer-content">
        <div className="footer-logo">
          {notShowLogo ? '' : <img src={Logo} alt="Sobre Rodas" />}
        </div>
        {!isMobile && (
          <div className="footer-copyright">
            <Text size="sm">
              <FontAwesomeIcon icon={faCopyright} /> 2026 Work Inteligência
            </Text>
          </div>
        )}
      </div>
    </footer>
  );
};

export default ConfirmationFooter;
